<div class="custom-dialog-container relative confirmation-dialog">
  <mat-dialog-content class="!overflow-hidden">
    <div class="min-h-[120px] my-5 flex flex-col justify-center gap-4">
      @if (data.exists) {
        <div class="flex justify-center items-center min-h-fit min-w-fit">
          <mat-icon class="text-primary bg-slate-100 min-h-fit min-w-fit text-[45px] rounded-full p-4" svgIcon="c:folder"></mat-icon>
        </div>
        <div class="font-sans font-bold text-xl flex !justify-center text-center text-primary">
          Export Already Generated
        </div>
        <div class="text-center text-gray-700 text-sm">
          An export for this work order was already generated. You can download it now or export again.
        </div>
      }

      @if (inProgress) {
        <div class="flex justify-center items-center min-h-fit min-w-fit">
          <mat-icon class="text-primary bg-slate-100 min-h-fit min-w-fit text-[45px] rounded-full p-4" svgIcon="c:clock-circle"></mat-icon>
        </div>
        <div class="font-sans font-bold text-xl flex !justify-center text-center text-primary">
          Export In Progress
        </div>
        <div class="text-center text-gray-700 text-sm">
          Export is already in progress for this work order. You will receive an email when it completes.
        </div>
      }

      @if (!data.exists && !inProgress) {
        <div class="flex justify-center items-center min-h-fit min-w-fit">
          <mat-icon class="text-green bg-green-100 min-h-fit min-w-fit text-[45px] rounded-full p-4" svgIcon="c:check-circle"></mat-icon>
        </div>
        <div class="font-sans font-bold text-xl flex !justify-center text-center text-primary">
          Export Started
        </div>
        <div class="text-center text-gray-700 text-sm">
          You will receive an email with the download link when your export is ready.
        </div>
        @if (data.estimatedTime) {
          <div class="text-center text-gray-500 text-xs">
            Est. {{ data.estimatedTime }}
          </div>
        }
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="flex !justify-center gap-2 !pb-7 flex-nowrap">
    @if (data.exists) {
      <button mat-flat-button mat-dialog-close color="accent" class="text-primary secondary-button !whitespace-nowrap">Cancel</button>
      <button mat-flat-button color="primary" (click)="onDownloadExisting()" class="text-primary primary-button !whitespace-nowrap">Download Existing</button>
      <button mat-flat-button color="primary" (click)="onExportAgain()" class="text-primary primary-button !whitespace-nowrap">Export Again</button>
    }

    @if (!data.exists) {
      <button mat-flat-button mat-dialog-close color="primary" class="text-primary primary-button">OK</button>
    }
  </mat-dialog-actions>
</div>
